<template>
  <div v-if="rows.length" class="gd-list">
    <div v-for="(item, i) in rows" :key="i" class="gd-row">
      <div class="gd-label">{{ item.title || item.id }}</div>
      <div class="gd-value">
        <!-- attach-file -->
        <template v-if="item.dataType === 'attach-file'">
          <file-preview :files="fileList(item.value)" />
        </template>

        <!-- digital-signature -->
        <template v-else-if="item.dataType === 'digital-signature'">
          <a v-if="sigLink(item.value)" :href="sigLink(item.value)" target="_blank" rel="noopener">
            <img :src="sigLink(item.value)" class="gd-sig" alt="signature" />
          </a>
          <div v-else class="gd-sig-empty">
            <v-icon size="22" color="#979797">mdi-draw</v-icon>
            <span>Signature on file</span>
          </div>
        </template>

        <!-- measurement-unit -->
        <template v-else-if="item.dataType === 'measurement-unit'">
          {{ measurement(item.value) }}
        </template>

        <!-- everything else (text / numeric / date / radio / checkbox) -->
        <template v-else>{{ scalar(item.value) }}</template>
      </div>
    </div>
  </div>
</template>

<script>
import FilePreview from "./FilePreview.vue";

export default {
  name: "GetDataAnswerList",
  components: { "file-preview": FilePreview },
  props: {
    items: { type: Array, default: () => [] },
  },
  computed: {
    rows() {
      return (this.items || []).filter(
        (r) => r && r.value !== undefined && r.value !== null && r.value !== ""
      );
    },
  },
  methods: {
    fileList(v) {
      const arr = Array.isArray(v) ? v : v ? [v] : [];
      return arr.map((f) => ({
        fileName: f.fileName || f.name || "",
        fileUrl: f.fileUrl || f.attachmentLink || f.link || "",
      }));
    },
    sigLink(v) {
      if (!v) return null;
      return v.attachmentLink || v.link || (typeof v === "string" ? v : null);
    },
    measurement(v) {
      if (v && typeof v === "object") {
        return `${v.value !== undefined && v.value !== null ? v.value : ""} ${v.abbr || v.name || ""}`.trim();
      }
      return v != null ? String(v) : "—";
    },
    scalar(v) {
      if (Array.isArray(v)) return v.join(", ");
      if (v && typeof v === "object") return this.measurement(v);
      return v != null ? String(v) : "—";
    },
  },
};
</script>

<style scoped>
.gd-list {
  margin-top: 2px;
}
.gd-row {
  display: flex;
  gap: 20px;
  padding: 9px 0;
  border-bottom: 1px solid #e8e8e8;
  align-items: flex-start;
}
.gd-row:last-child {
  border-bottom: 0;
}
.gd-label {
  width: 200px;
  flex-shrink: 0;
  font-size: 13px;
  color: #787878;
}
.gd-value {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #1e1e1e;
}
.gd-muted {
  color: #979797;
  font-weight: 400;
}
.gd-file {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}
.gd-file:last-child {
  margin-bottom: 0;
}
.gd-file-icon {
  color: #117443 !important;
}
.gd-link {
  font-size: 13px;
  color: #117443;
  text-decoration: underline;
}
.gd-link:hover {
  color: #0ebf67;
}
.gd-sig {
  max-width: 130px;
  max-height: 78px;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  background: #f8f8f8;
}
.gd-sig-empty {
  width: 130px;
  height: 78px;
  border: 1px solid #e3e3e3;
  border-radius: 8px;
  background: #f8f8f8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 10px;
  color: #787878;
}
</style>
